import api from "@/api.js";

export default {
  state: {
    emailTemplates: [],
    emailTemplatesLoading: false
  },
  mutations: {
    setEmailTemplates(state, payload) {
      state.emailTemplates = payload;
    },
    setEmailTemplatesLoading(state, payload) {
      state.emailTemplatesLoading = payload;
    }
  },
  actions: {
    async loadEmailTemplates({ commit }) {
      commit("setEmailTemplatesLoading", true);
      let emailTemplates = await api.get("emailTemplates");
      commit("setEmailTemplates", emailTemplates.data);
      commit("setEmailTemplatesLoading", false);
    },
    async saveEmailTemplate({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`emailTemplates`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadEmailTemplates");
      return returnData;
    },
    async newEmailTemplate({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`emailTemplates`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadEmailTemplates");
      return returnData;
    },
    async saveEmailTemplateContent({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`emailTemplates/template`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadEmailTemplates");
      return returnData;
    }
  },
  getters: {
    emailTemplates(state) {
      return state.emailTemplates;
    },
    emailTemplatesLoading(state) {
      return state.emailTemplatesLoading;
    }
  }
};
